import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxPopperjsModule } from 'ngx-popperjs';

import { GeneralTooltipComponent } from './general-tooltip.component';
import { InlineTooltipComponent } from './inline-tooltip.component';
import { OnboardingTooltipComponent } from './onboarding-tooltip.component';

@NgModule({
    imports: [CommonModule, NgxPopperjsModule, InlineTooltipComponent],
    declarations: [GeneralTooltipComponent, OnboardingTooltipComponent],
    exports: [InlineTooltipComponent, GeneralTooltipComponent, OnboardingTooltipComponent],
})
export class TooltipModule {}
